import React from 'react';
import MessageContext from '../MessageContext';

export default function MessageProvider(props) {
  const { children } = props;
  return <MessageContext.Provider>{children}</MessageContext.Provider>;
}
